import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./sidebar/Sidebar";
import Upload from "./upload/upload";
import Posts from "./posts/Posts";
import EmployeeOnBoard from "./employeeOnboard/EmployeeOnBoard";
import HR from "./admin/approvereject/hr";
import Comment from "./admin/comment/comments";
import Delete from "./admin/delete/HrDelete";
import PeopleTree from "./organization/PeopleTree";
import MenusHome from "./admin/menuscren/MenuScreen";
import "./Home.css";
import CommitteePanel from "./organization/committePanel/Panel";
import CommitteeAdmin from "./admin/committee/CommitteeAdmin";
import { getAdminAccess } from "../../api/ApiConfig"; 
import SkillMatrix from "./organization/skillMatrix/SkillMatrix";

export default function Home() {
  const location = useLocation();
  const path = location.pathname;

  // State to store the admin access information
  const [adminAccess, setAdminAccess] = useState({
    has_committee_admin_access: false,
    emp_id: null,
  });
  // State to track loading status
  const [isLoading, setIsLoading] = useState(true);

  // Effect to fetch the admin access on component mount
  useEffect(() => {
    const fetchAccess = async () => {
      try {
        // Fetch the data from the API
        const response = await getAdminAccess();
        // Assuming getAdminAccess returns the object { has_committee_admin_access: boolean, emp_id: string }
        setAdminAccess(response);
      } catch (error) {
        console.error("Error fetching admin access:", error);
        // Set default access on error, or handle as needed
        setAdminAccess({ has_committee_admin_access: false, emp_id: null });
      } finally {
        setIsLoading(false);
      }
    };

    fetchAccess();
  }, []); // Empty dependency array ensures it runs only once on mount

  // Destructure the committee access flag for cleaner use
  const { has_committee_admin_access } = adminAccess;

  // Render a loading state while fetching access data
  if (isLoading) {
    return <div className="loading-screen">Loading application data...</div>;
  }

  return (
    <div className="home-container">
      <div className="sidebar-wrapper">
        <Sidebar />
      </div>

      {/* Conditional rendering based on path */}
      {path === "/home" && (
        <main className="main-content">
          <section className="upload-section">
            <Upload />
          </section>
          <section className="posts-section">
            <Posts />
          </section>
        </main>
      )}

      {path === "/hr" && (
        <main className="main-content">
          <section className="upload-section">
            <HR />
          </section>
        </main>
      )}
      {path === "/comment" && (
        <main className="main-content">
          <section className="upload-section">
            <Comment />
          </section>
        </main>
      )}
      {path === "/delete" && (
        <main className="main-content">
          <section className="upload-section">
            <Delete />
          </section>
        </main>
      )}
      {path === "/menus" && (
        <main className="main-content">
          <section className="upload-section">
            <MenusHome />
          </section>
        </main>
      )}
      {path === "/peoplefinder" && (
        <main className="main-content">
          <section className="upload-section">
            <PeopleTree />
          </section>
        </main>
      )}

      {path === "/Skill-finder" && (
        <main className="main-content">
          <section className="upload-section">
            <SkillMatrix />
          </section>
        </main>
      )}

      {path === "/CommitteesPanelsCohorts" && (
        <main className="main-content">
          <section className="upload-section">
            <CommitteePanel />
          </section>
        </main>
      )}

      {/* NEW LOGIC: Render CommitteeAdmin ONLY if the path is /committeeAdmin 
        AND the user has been granted committee admin access. 
      */}
      {path === "/committeeAdmin" && has_committee_admin_access && (
        <main className="main-content">
          <section className="upload-section">
            <CommitteeAdmin />
          </section>
        </main>
      )}
      {/* Optional: Add a message if the user tries to access but is denied */}
      {path === "/committeeAdmin" && !has_committee_admin_access && (
        <main className="main-content">
          <section className="access-denied">
            <p>🚫 **Access Denied:** You do not have permission to view the Committee Admin panel.</p>
          </section>
        </main>
      )}

      <aside className="onboard-section">
        <EmployeeOnBoard />
      </aside>
    </div>
  );
}